// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"117":"admin-features","260":"admin-dashboard","527":"admin-login","557":"economic-settings","816":"economic-accounting"}[chunkId] + "." + {"117":"9357a18d","260":"6a6b332e","527":"20c2ef90","557":"e806d26b","816":"90257bc5"}[chunkId] + ".css";
};